import React, { useState, useCallback } from 'react';
import {
  Box,
  useTheme,
  Dialog,
  useMediaQuery,
  DialogContent,
  DialogActions,
  Button,
  DialogTitle,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { IItem } from 'api/catalog/models';
import { useToggle } from 'hooks';
import ImageCarousel from 'ui/ImageCarousel';

import messages from '../messages';

interface IProps {
  assets: IItem['assets'];
}

const AssetDataCell = ({ assets = [] }: IProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { val: isLargeViewOpen, toggle: toggleIsLargeViewOpen } =
    useToggle(false);
  const [initialIndexToOpen, setInitialIndexToOpen] = useState(0);

  const handleAssetClick = useCallback(
    (index = 0) => {
      setInitialIndexToOpen(index);
      toggleIsLargeViewOpen();
    },
    [toggleIsLargeViewOpen]
  );

  return (
    <React.Fragment>
      <Box display='flex' alignItems='center'>
        {assets?.map((asset, index) => (
          <a
            key={index}
            onClick={() => handleAssetClick(index)}
            style={{ cursor: 'pointer' }}
          >
            <img
              title={asset.source}
              style={{
                maxHeight: '50px',
                maxWidth: '50px',
                marginLeft: '3px',
                border: `1px solid ${theme.palette.divider}`,
              }}
              src={asset.source}
            />
          </a>
        ))}
      </Box>
      {isLargeViewOpen ? (
        <Dialog
          fullScreen={isMobile}
          open={isLargeViewOpen}
          onClose={toggleIsLargeViewOpen}
        >
          <DialogTitle>
            <FormattedMessage {...messages.assetModalTitle} />
          </DialogTitle>
          <DialogContent>
            <ImageCarousel assets={assets} initialIndex={initialIndexToOpen} />
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={toggleIsLargeViewOpen}>
              <FormattedMessage {...messages.closeButton} />
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </React.Fragment>
  );
};

export default AssetDataCell;
